// Define constants events
export const EVENTS = {
    SHOPIFY_CLOSED_FAILURE: 'Closing Failed',
    GET_DATA_SUCCESS: 'GET_DATA_SUCCESS',
    GET_DATA_FAILURE: 'GET_DATA_FAILURE',
    GET_SHOPIFY_DASHBOARD_DATA_SUCCESS: 'GET_SHOPIFY_DASHBOARD_DATA_SUCCESS',
    GET_SHOPIFY_DASHBOARD_DATA_FAILURE: 'GET_SHOPIFY_DASHBOARD_DATA_FAILURE',
   };
   
    